<template>
  <Page class="page-container--scrollable-table">
    <PageContent>
      <InShareTabs />
      <RouterView />
    </PageContent>
  </Page>
</template>

<script lang="ts" setup>
import { RouteName } from '@/types/router'
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import { useInSharesContext } from '@/composables/deepbox/use-in-shares-context.ts'
import { useBreadcrumbRegistry } from '@/composables/use-breadcrumb-registry.ts'
import InShareTabs from '@/components/deepbox/in-share/InShareTabs.vue'
import Page from '@/components/page/Page.vue'
import PageContent from '@/components/page/PageContent.vue'

definePage({
  meta: {
    breadcrumbLabelKey: '',
  },
})

const { overrideBreadcrumb } = useBreadcrumbRegistry()
const { permissions } = useAuthorizationContext()
const { selectedInShare, isSuccess } = useInSharesContext()

watch(
  selectedInShare,
  (newValue) => {
    if (!newValue) return

    overrideBreadcrumb(
      '/organizations/[organizationId]/deepbox/in-shares/[shareId]' as RouteName,
      newValue.boxName || '',
    )
  },
  { immediate: true },
)

usePageAccess(
  computed(() => !permissions.canManageInShares || !selectedInShare.value),
  '/organizations/[organizationId]/deepbox/in-shares/',
  computed(() => !isSuccess.value),
  true,
)
</script>
